import { Activity } from "../../../../models/activity/activity";
import { KeyValueObject } from "../../../../models/core/KeyValueObject";

export class CompleteActivityResultPropertiesData {
    
    activity: Activity = null;
    activityResults: KeyValueObject[] = [];
    unsetBIOReasons: KeyValueObject[] = [];
    activityResultIds: number[] = [];
    completedDateTime: Date;
    requireSetBIO: boolean;
	setBIO: boolean;
	unsetBIOReason: string;
}